import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { CheckboxCustomEvent, IonCheckbox } from '@ionic/angular/standalone';

import { SvgIconComponent } from '../../icons/svg-icon/svg-icon.component';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
    selector: 'lib-checkbox',
    standalone: true,
    imports: [CommonModule, IonCheckbox, ReactiveFormsModule, InputWrapperComponent, SvgIconComponent],
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.css'
})
export class CheckboxComponent {
    /* eslint-disable */
    @Input() label: string = '';
    @Input() form: FormGroup = new FormGroup({
        input: new FormControl(false)
    });
    @Input() controlName: string | null = 'input';
    @Input() required: boolean = false;
    @Input() submitAttempt: boolean = false;
    @Input() subtext: string | null = null;
    @Input() ionItemWrap: boolean = true;
    @Input() checked: boolean = false;
    @Input() disabled: boolean = false;
    @Input() indeterminate: boolean = false;
    @Input() color: 'default' | 'primary' = 'default';
    @Input() hideContent: boolean = false;
    @Input() preventClickPropagation: boolean = false;

    @Output() onCheckboxClick: EventEmitter<boolean> = new EventEmitter<boolean>();

    formInput: AbstractControl | null = null;

    constructor() {}

    @HostListener('click', ['$event']) onClick($event: PointerEvent) {
        if (this.preventClickPropagation) {
            $event.stopPropagation();
            $event.preventDefault();
        }
    }

    onChange(event: CheckboxCustomEvent) {
        this.onCheckboxClick.emit(event.detail.checked);
    }
}
